/**
 * @desc 获取所有sku编号及中文名
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.SkuNoAndNameResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/sku/getAllSkuSimple`, {
      method: "GET",

      ...options,
    }),
  );
}
